import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { CostsScreenValidationResult } from '../../../../../../../@types/validation-types'
import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'

const HasCourtage: React.FC<FieldProps<CostsScreenValidationResult>> = ({ insertionData, onChange }) => {
  const { t } = useTranslation()
  const translation = `${t('wizard.screen.costs.hasCourtage', 'Has courtage')}${insertionData.hasCourtage ? '*' : ''}`
  return (
    <div className='grid-item one-whole'>
      <ToggleSwitch
        id='has-courtage'
        alignment='custom'
        propertyName='hasCourtage'
        label={translation}
        value={insertionData.hasCourtage ?? false}
        onChange={(field, value) => onChange({ screen: 'costs', property: field }, value)}
      />
    </div>
  )
}

export default HasCourtage
